import { render, staticRenderFns } from "./ViewPayments.vue?vue&type=template&id=326ead9a&scoped=true"
import script from "./ViewPayments.vue?vue&type=script&lang=js"
export * from "./ViewPayments.vue?vue&type=script&lang=js"
import style0 from "./ViewPayments.vue?vue&type=style&index=0&id=326ead9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326ead9a",
  null
  
)

export default component.exports